import { Box, Card, IconButton, Stack, styled } from '@mui/material';

export const DialogPaperSx = {
  width: '95vw',
  maxWidth: '1800px',
};

export const Root = styled(Box)({
  height: '80vh',
});

export const Layout = styled(Stack)({
  height: '100%',
  flexDirection: 'row',
});

export const MainPreview = styled(Box)({
  flex: 1,
  position: 'relative',
  backgroundColor: '#fff',
});

export const NavButton = styled(IconButton)({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: 44,
  height: 44,
  backgroundColor: '#fff',
  color: '#111',
  zIndex: '999',
  border: '1px solid rgba(0,0,0,0.15)',
  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
  '&:hover': {
    backgroundColor: '#fff',
    boxShadow: '0 3px 8px rgba(0,0,0,0.25)',
  },
  '&:active': {
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  },
});

export const PreviewTitle = styled(Box)({
  position: 'absolute',
  top: 12,
  left: 12,
  maxWidth: '70%',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '10px 12px',
  borderRadius: 12,
  backgroundColor: '#fff',
  color: '#111',
  border: '1px solid rgba(0,0,0,0.15)',
  fontSize: 14,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  zIndex: 2,
});

export const ContentCenter = styled(Box)({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
});

export const BottomToolbar = styled(Box)({
  position: 'absolute',
  left: '50%',
  bottom: 16,
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(0,0,0,0.04)',
  border: '1px solid rgba(0,0,0,0.08)',
  borderRadius: 999,
  padding: '12px 12px',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  backdropFilter: 'blur(6px)',
});

export const Sidebar = styled(Box)({
  width: 320,
  borderLeft: '1px solid #eee',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
});

export const SidebarHeader = styled(Stack)({
  padding: 8,
  justifyContent: 'flex-end',
});

export const CloseButton = styled(IconButton)({
  backgroundColor: '#fff',
  border: '1px solid rgba(0,0,0,0.15)',
  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
  '&:hover': {
    backgroundColor: '#fff',
    boxShadow: '0 3px 8px rgba(0,0,0,0.35)',
  },
});

export const UploadRow = styled(Box)({
  padding: 8,
  marginBottom: 8,
  display: 'flex',
  justifyContent: 'flex-end',
});

export const ListContainer = styled(Box)({
  overflow: 'auto',
  flex: 1,
  padding: 8,
});

export const PhotoCard = styled(Card)({
  cursor: 'pointer',
  position: 'relative',
});

export const CardMenuButton = styled(IconButton)({
  position: 'absolute',
  top: 6,
  right: 6,
  zIndex: 1,
  backgroundColor: '#fff',
  '&:hover': { backgroundColor: '#f5f5f5' },
});
